module.exports = __webpack_public_path__ + "static/media/SuisseIntl-Regular-WebS.eb5bb203.ttf";